import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { ToastService } from '../../_services/toast.service';

@Component({
  selector: 'app-opt-out-subscribe',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,RouterModule ],
  templateUrl: './opt-out-subscribe.component.html',
  styleUrl: './opt-out-subscribe.component.scss'
})
export class OptOutSubscribeComponent implements OnInit {
  unsubscribeForm:any = FormGroup;
  email: string = ''
  loading      = false;
  submitted    = false;
  errorMessage = '';

 constructor(private fb: FormBuilder, private route: ActivatedRoute,private _US: AuthService, private _NS : ToastService ) {}

 ngOnInit(): void {
   this.email = this.route.snapshot.paramMap.get('email') || ''
   this.formBuilder()
 }

  formBuilder(){
    this.unsubscribeForm = this.fb.group({
      email: [this.email,Validators.required],
      alreadyPurchased: [false,Validators.required],
      noLongerLooking: [false, Validators.required],
      technicalIssues: [false,Validators.required],
      switchingService: [false,Validators.required],
      notRelevant: [false,Validators.required],
      manyNotifications: [false,Validators.required],
      feedback: ['',Validators.required]
    });
  }

  submitForm(): void {
    if (!this.unsubscribeForm.valid) {
      this._NS.error('Invalid or missing email address/feedback.')
      this.errorMessage = 'Invalid or missing email address/invalid.';
      return;
    }
    this.loading      = true;
    this.errorMessage = '';
    this._US.optOut(this.unsubscribeForm.value).subscribe({
      next: (res:any) => {
        this.loading   = false;
        this.submitted = true;
        console.log(res)
        this._NS.success(res.message)
      },
      error: (err) => {
        this.loading      = false;
        this.errorMessage = err?.error?.message ?? 'Something went wrong. Please try again.';
      },
    });
  }
}
